import {
  UilUsersAlt,
  UilBuilding,
  UilChartPieAlt,
  UilCalendarAlt,
  UilClipboardAlt,
  UilSitemap,
} from "@iconscout/react-unicons";
import React from "react";

// Map route names to their respective icons
export const ROUTE_ICONS = {
  analytics: <UilChartPieAlt size="20" />,
  lead: <UilUsersAlt size="20" />,
  automation: <UilSitemap size="20" />,
  appointments: <UilCalendarAlt size="20" />,
  sales: <UilClipboardAlt size="20" />,
  // fallback icon
  default: <UilBuilding size="20" />,
};
